import { pick } from 'lodash';
import { create as createStore } from 'zustand';
import { persist } from 'zustand/middleware';

import {
  createDocumentSigningSlice,
  DocumentSigningSlice,
} from './states/documentSigning';
import { createFilterSlice, type FilterSlice } from './states/filter';
import { createResetSlice, type ResetSlice } from './states/reset';
import { createSessionSlice, type SessionSlice } from './states/session';
import {
  createTableGroupExpansionSlice,
  TableGroupExpansionsSlice,
} from './states/tableGroupExpansions';
import { createUiSlice, type UiSlice } from './states/ui';
import {
  createWorkflowStateSelectionSlice,
  type WorkflowStateSelectionSlice,
} from './states/workflowStateSelection';

export type StateSlices = FilterSlice &
  ResetSlice &
  SessionSlice &
  UiSlice &
  WorkflowStateSelectionSlice &
  TableGroupExpansionsSlice &
  DocumentSigningSlice;

export const useStore = createStore<StateSlices>()(
  persist(
    (...a) => ({
      ...createFilterSlice(...a),
      ...createResetSlice(...a),
      ...createSessionSlice(...a),
      ...createUiSlice(...a),
      ...createWorkflowStateSelectionSlice(...a),
      ...createTableGroupExpansionSlice(...a),
      ...createDocumentSigningSlice(...a),
    }),
    {
      name: 'portal-next-state',
      partialize: (state) => pick(state, 'isNavigationCollapsed'),
      version: 1,
    }
  )
);
